__webpack_require__.p = "https://stage-poker-webapp-client.safe-iplay.com/";